import React from "react";
import xochitl from "../img/xóchitl.jpg";
import logo from "../img/8. Imagotipo-El-Universal-Vertical_Cuadrado_Azul.png";

const Claudia = () => {
  return (
    <div>
      <div className="introduccion">
        <p className="quiz">Resultado</p>
        <p className="titulo-quiz">
          ¡Te pareces a <br />{" "}
          <span style={{ color: "#3382AF" }}>Xóchitl Gálvez</span>!
        </p>
        <p className="descripcion-quiz">
          ¡Felicidades! Se ve que ya no tienes miedo y apuestas por un cambio.
          Si fuera por ti, el dicho de "abrazos, no balazos" ya sería historia..
        </p>
      </div>

      
      <div className="redes-sociales">
  {/*Facebook */}

  <a
  className="facebook"
  href="https://www.facebook.com/share.php?u=https://www.eluniversal.com.mx/eres-claudia-eres-xochitl-2024/"
  title="Compartir en Facebook"
  target="_blank"
>

  <svg className="svg-share" viewBox="0 0 448 512">
    <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"></path>
  </svg>
</a>

{/**Twitter */}
<a
  className="twitter-x"
  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent('https://www.eluniversal.com.mx/eres-claudia-eres-xochitl-2024/')}&text=${encodeURIComponent('Con qué candidata te identificas')}`}
  target="_blank"
>
  <svg className="svg-share" viewBox="0 0 512 512">
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path>
  </svg>
</a>


{/*whats */}

     
<a
  className="whatsapp"
  href="https://api.whatsapp.com/send?text=https://www.eluniversal.com.mx/eres-claudia-eres-xochitl-2024/"
  target="_blank"
>
          <svg class="svg-share" viewBox="0 0 448 512">
            <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
          </svg>
        </a>

{/*Messenger */}
{/*Messenger */}
<a
  itemprop="url"
  href={`http://www.facebook.com/dialog/send?app_id=1972593456332727&link=${encodeURIComponent('https://www.eluniversal.com.mx/eres-claudia-eres-xochitl-2024/')}&redirect_uri=${encodeURIComponent('https://www.eluniversal.com.mx/eres-claudia-eres-xochitl-2024/')}`}
  className="messenger"
  onClick={(e) => {
    e.preventDefault();
    const facebookUrl = e.currentTarget.getAttribute('href');
    window.open(
      facebookUrl,
      "_blank",
      "width=500,height=400,scrollbars=1"
    );
  }}
>
  <svg className="svg-share" viewBox="0 0 512 512">
    <path d="M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"></path>
  </svg>
</a>
      </div>

      <div className="res-articulo">
        <div className="fondo-articulo">
          <img className="imag-candidata" src={xochitl} alt="xochitl" />
          <div className="nota-el-universal">
            <img
              style={{ height: "50px", margin: "10px", width: "auto" }}
              src={logo}
              alt="Imagotipo El Universal"
            />
            <span className="nota-titulo">
              Descubre las últimas noticias de la candidata{" "}
              <a
                style={{ color: "#3382AF" }}
                href="https://www.eluniversal.com.mx/tag/xochitl-galvez/"
              >
                Xóchtil Gálvez
              </a>
            </span>
          </div>
        </div>
      </div>

      <p className="elecciones">
        Entérate de lo último de las campañas presidenciales en nuestra sección
        de{" "}
        <a
          href="https://www.eluniversal.com.mx/elecciones/"
          target="_blank"
          rel="noreferrer"
        >
          Elecciones 2024
        </a>
      </p>
    </div>
  );
};

export default Claudia;
